import { getFieldsReportForm } from "../../../sims/appFormReportsUtility";
import moment from "moment";
import { showEmptyColumn } from "../CP_CrossingReport";
import React from "react";
import { Col, Row } from "reactstrap";

export const tableSection = (testSchedules) => {
  return testSchedules.map((testSched) => {
    const { testCode, title } = testSched;
    let arrayTest = allPossibleTables[testCode];

    if (arrayTest) {
      let data = arrayMethod(testSched);

      return data.length != 0 ? (
        <React.Fragment>
          {arrayTest(data, title)} {showEmptyColumn()}
        </React.Fragment>
      ) : null;
    }
  });
};

function arrayMethod(testSched) {
  let data = [];
  let table = testSched && testSched.formData && testSched.formData.find((field) => field && field.type === "table");
  if (table && table.value) {
    data = getFieldsReportForm(table.value);
  }
  return data;
}

const allPossibleTables = {
  CP_Monthly_FRA234_249: (data, title) => NomenclatureTable(data, title, "Bus Nomenclature"),
  CP_Quarterly_FRA234_269: (data, title) => NomenclatureTable(data, title, "Circuit Nomenclature"),
  CP_Monthly_FRA234_261: (data, title) => NomenclatureTable(data, title, "Device Nomenclature"),
  CP_Annual_FRA234_259: (data, title) => YWarningTimeTests(data, title),
  CP_Annual_FRA234_265: (data, title) => TimingRelayDevice(data, title),
  CP_Monthly_FRA234_259: (data, title) => MWarningTimeTests(data, title),
  CP_Annual_FRA234_253A: (data, title) => FlasherTestArrayResults(data, title),

  //fra
  FRA234_255c: (data, title) => NomenclatureTable(data, title, "Hold Clear Nomenclature"),
  FRA234_249: (data, title) => NomenclatureTable(data, title, "Bus Nomenclature"),
  FRA234_261: (data, title) => NomenclatureTable(data, title, "Device Nomenclature"),
  FRA234_253A: (data, title) => FlasherTestArrayResults(data, title),
  FRA234_265: (data, title) => TimingRelayDevice(data, title),
  FRA234_259: (data, title) => YWarningTimeTests(data, title),
  FRA234_269: (data, title) => NomenclatureTable(data, title, "Circuit Nomenclature"),

  FRA234_251: (data, title) => NomenclatureTable(data, title, "Standby Power Nomenclature"),
  FRA234_253M: (data, title) => NomenclatureTable(data, title, "Flashing Light Nomenclature"),
  FRA234_255: (data, title) => NomenclatureTable(data, title, "Gate Arm Nomenclature"),

  //NYSW
  NYSW_Annual_LampVoltage: (data, title) => NYSW_AnnualLampVoltageTable(data, title),
};

const NomenclatureTable = (ground, name, desc) => {
  return (
    <Col md={12}>
      <Row>
        <React.Fragment>
          <div className="section-heading">{name}</div>
          <Col md={6}>
            <div className="box-title">{desc}</div>
          </Col>
          <Col md={6}>
            <div className="box-title">Condition</div>
          </Col>

          {ground &&
            ground.map((ground) => (
              <React.Fragment>
                <Col md={6} className="border border-dark">
                  {ground.desc}
                </Col>

                <Col md={6} className="border border-dark">
                  {ground.test}
                </Col>

                <div className="comments-text info-section">{ground.com}</div>
              </React.Fragment>
            ))}
          <hr />
        </React.Fragment>
      </Row>
    </Col>
  );
};

const YWarningTimeTests = (warningData, name) => {
  return (
    <Col md={12} className="border border-dark table">
      <React.Fragment>
        <br />
        <div className="label-text">{name}</div>

        <table className="table crossing-tests">
          <thead>
            <tr>
              <th rowSpan={2} colSpan={4} style={{ borderBottom: "1px solid #000" }}>
                Route & Track Number
              </th>
              <th rowSpan={2} colSpan={2} style={{ borderBottom: "1px solid #000" }}>
                Equip.
              </th>
              <th rowSpan={2} colSpan={3} style={{ borderBottom: "1px solid #000" }}>
                Direction
              </th>
              <th rowSpan={2} colSpan={3} style={{ borderBottom: "1px solid #000" }}>
                Active / Standby
              </th>
              <th rowSpan={2} colSpan={1} style={{ borderBottom: "1px solid #000" }}></th>
              <th rowSpan={2} colSpan={3} style={{ borderBottom: "1px solid #000" }}>
                Control Type
              </th>
              <th rowSpan={2} colSpan={3} style={{ borderBottom: "1px solid #000" }}>
                Timing Method
              </th>
              <th rowSpan={1} colSpan={2}>
                Time (seconds)
              </th>
              <th rowSpan={2} colSpan={2} style={{ borderBottom: "1px solid #000" }}>
                Test Date
              </th>
            </tr>
            <tr>
              <th rowSpan={1} colSpan={1} style={{ borderBottom: "1px solid #000" }}>
                Presc.
              </th>
              <th rowSpan={1} colSpan={1} style={{ borderBottom: "1px solid #000" }}>
                Obs.
              </th>
            </tr>
          </thead>
          <tbody>
            {warningData.map((data, index) => {
              return (
                <React.Fragment>
                  {" "}
                  <tr>
                    <td colSpan={4}>
                      {data.rout} {data.track ? `/ ${data.track}` : ""}
                    </td>
                    <td colSpan={2}>{data.etype}</td>
                    <td colSpan={3}>{data.dir}</td>
                    <td colSpan={3}>{data.asby}</td>
                    <td colSpan={1}>
                      {" "}
                      <span className="value-box">{data.test}</span>
                    </td>
                    <td colSpan={3}>{data.ctype}</td>
                    <td colSpan={3}>{data.method}</td>
                    <td colSpan={1}>{data.tpresc}</td>
                    <td colSpan={1}>{data.tobs}</td>
                    <td colSpan={2}>{data.tdate ? moment(data.tdate).format("MM-DD-YYYY") : ""}</td>
                  </tr>
                  <tr>
                    <td colSpan={13}>
                      <span style={{ display: "block", textAlign: "left", marginLeft: "10px" }}>
                        <strong>Comments : </strong>
                        {data.com}
                      </span>
                    </td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </React.Fragment>
    </Col>
  );
};

const NYSW_AnnualLampVoltageTable = (data, title) => {
  return (
    <Col md={12} className="border border-dark table">
      <React.Fragment>
        <br />
        <div className="label-text">{title}</div>

        <Col md={12}>
          <table className="table TimingRelay">
            <tbody>
              <tr>
                <th colSpan={2}>
                  <div>Lamp Nomenclature</div>
                </th>

                <th colSpan={1}>
                  <div>AC Reading (V)</div>
                </th>
                <th colSpan={1}>
                  <div>DC Reading (V)</div>
                </th>
                <th colSpan={1}>
                  <div>Condition</div>
                </th>
                <th colSpan={4}>
                  <div>Comments</div>
                </th>
              </tr>
            </tbody>
            {data.map((time, index) => (
              <React.Fragment key={`r.f-${index}`}>
                <tbody>
                  <tr>
                    <td colSpan={2}>{time.desc}</td>

                    <td colSpan={1}>{time.acread}</td>

                    <td colSpan={1}>{time.dcread}</td>
                    <td colSpan={1}>
                      <div className="value-box">{time.test}</div>
                    </td>
                    <td colSpan={4}>{time.com}</td>
                  </tr>
                </tbody>
              </React.Fragment>
            ))}
          </table>
        </Col>
      </React.Fragment>
    </Col>
  );
};

const TimingRelayDevice = (data, name) => {
  return (
    <Col md={12} className="border border-dark table">
      <React.Fragment>
        <br />
        <div className="label-text">{name}</div>

        <Col md={12}>
          <table className="table TimingRelay">
            <tbody>
              <tr>
                <th colSpan={2}>
                  <div>Timer Nomenclature & Design / Plan Time</div>
                </th>
                <th colSpan={1}>
                  <div>Condition</div>
                </th>
                <th colSpan={1}>
                  <div>Measured Time</div>
                </th>
                <th colSpan={4}>
                  <div>Comments</div>
                </th>
              </tr>
            </tbody>
            {data.map((time, index) => (
              <React.Fragment key={`r.f-${index}`}>
                <tbody>
                  <tr>
                    <td colSpan={2}>
                      {time.desc}
                      {time.dpt ? ` / ${time.dpt}` : ""}
                    </td>
                    <td colSpan={1}>
                      <div className="value-box">{time.test}</div>
                    </td>
                    <td colSpan={1}>{time.met}</td>
                    <td colSpan={4}>{time.com}</td>
                  </tr>
                </tbody>
              </React.Fragment>
            ))}
          </table>
        </Col>
      </React.Fragment>
    </Col>
  );
};
const MWarningTimeTests = (warningData, name) => {
  return (
    <Col md={12} className="border border-dark table">
      <React.Fragment>
        <br />
        <div className="label-text">{name}</div>

        <table className="table crossing-tests">
          <thead>
            <tr>
              <th rowSpan={2} colSpan={4} style={{ borderBottom: "1px solid #000" }}>
                Track#
              </th>
              <th rowSpan={2} colSpan={3} style={{ borderBottom: "1px solid #000" }}>
                Direction
              </th>
              <th rowSpan={2} colSpan={3} style={{ borderBottom: "1px solid #000" }}>
                Active / Standby
              </th>
              <th rowSpan={2} colSpan={1} style={{ borderBottom: "1px solid #000" }}></th>
              <th rowSpan={2} colSpan={3} style={{ borderBottom: "1px solid #000" }}>
                Control Type
              </th>
              <th rowSpan={2} colSpan={3} style={{ borderBottom: "1px solid #000" }}>
                Timing Method
              </th>
              <th rowSpan={1} colSpan={2}>
                Time (seconds)
              </th>
              <th rowSpan={2} colSpan={2} style={{ borderBottom: "1px solid #000" }}>
                Test Date
              </th>
            </tr>
            <tr>
              <th rowSpan={1} colSpan={1} style={{ borderBottom: "1px solid #000" }}>
                Presc.
              </th>
              <th rowSpan={1} colSpan={1} style={{ borderBottom: "1px solid #000" }}>
                Obs.
              </th>
            </tr>
          </thead>
          <tbody>
            {warningData.map((data, index) => {
              return (
                <React.Fragment>
                  {" "}
                  <tr>
                    <td colSpan={4}>{data.track}</td>
                    <td colSpan={3}>{data.dir}</td>
                    <td colSpan={3}>{data.asby}</td>
                    <td colSpan={1}>
                      {" "}
                      <span className="value-box">{data.test}</span>
                    </td>
                    <td colSpan={3}>{data.ctype}</td>
                    <td colSpan={3}>{data.method}</td>
                    <td colSpan={1}>{data.tpresc}</td>
                    <td colSpan={1}>{data.tobs}</td>
                    <td colSpan={2}>{data.tdate ? moment(data.tdate).format("MM-DD-YYYY") : ""}</td>
                  </tr>
                  <tr>
                    <td colSpan={8}>
                      <span style={{ display: "block", textAlign: "left", marginLeft: "10px" }}>
                        <strong>Route : </strong>
                        {data.rout}
                      </span>
                    </td>
                    <td colSpan={13}>
                      <span style={{ display: "block", textAlign: "left", marginLeft: "10px" }}>
                        <strong>Comments : </strong>
                        {data.com}
                      </span>
                    </td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </React.Fragment>
    </Col>
  );
};

const FlasherTestArrayResults = (FlasherTestResults, name) => {
  let results = [];
  if (FlasherTestResults && FlasherTestResults.length > 0)
    results = FlasherTestResults.map((fr) => {
      return (
        <React.Fragment>
          <Col md={6} style={{ borderLeft: "1px solid #000", padding: "5px 15px", borderBottom: "1px solid #000" }}>
            <div className="label-text">{fr.desc}</div>
            <div className="value-box">{fr.test}</div>
            <div className="comments-text info-section">{fr.com}</div>
          </Col>

          <Col md={6} style={{ borderRight: "1px solid #000", padding: "5px 15px", borderBottom: "1px solid #000" }}>
            <Col md={6} className="border border-dark">
              {fr.flash}
            </Col>
            <Col md={6}></Col>
            <br />
          </Col>
        </React.Fragment>
      );
    });
  return (
    <React.Fragment>
      <Col md={12} style={{ borderLeft: "1px solid #000", borderRight: "1px solid #000", borderTop: "1px solid #000" }}>
        <br />
        <div className="label-text">{name}</div>
        <br />
      </Col>

      <Col md={6} style={{ borderLeft: "1px solid #000", borderBottom: "1px solid #000" }}>
        <div className="box-title" style={{ textAlign: "left" }}>
          Flasher Nomenclature
        </div>
      </Col>
      <Col md={6} style={{ borderRight: "1px solid #000", borderBottom: "1px solid #000" }}>
        <div className="box-title" style={{ textAlign: "left" }}>
          Flashes Per Minute
        </div>
      </Col>

      {results}
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/Reports/CP/NewCrossingReport/ReportSections/tableSection.jsx